//todo remove when get rid of airtable

export const convertAirTableCompany = (oldObj) => {
	if (oldObj.fields) {
		return {
			id: oldObj.fields['Record Id'],
			name: oldObj.fields['Legal Name'],
		};
	} else {
		return {
			id: oldObj['Record Id'],
			name: oldObj['Legal Name'],
		};
	}
};

export const convertAirTableUser = (oldObj) => {
	if (oldObj.fields) {
		return {
			id: oldObj.id,
			firstName: oldObj.fields['First Name'],
			lastName: oldObj.fields['Last Name'],
			email: oldObj.fields['Email'],
		};
	} else {
		return {
			id: oldObj.id,
			firstName: oldObj['First Name'],
			lastName: oldObj['Last Name'],
			email: oldObj['Email'],
		};
	}
};
